var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto mb-4",attrs:{"outlined":""}})}
var staticRenderFns = []

export { render, staticRenderFns }